
export default {
  name: 'PricingComparisonTable',
  props: { comparisonMatrix: { type: Object, default: () => {} } },
}
